import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["size", "color", "alignWithText", "aria-label", "id"];
// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

import { useTheme } from 'foundations-theming/utils';
import { useIconSize } from 'foundations-assets/icons/useIconSize';
import { StyledIcon } from 'foundations-assets/icons/StyledIcon';
import { getDataProps } from 'foundations-assets/icons/getDataProps';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const CommunicationIcon = _ref => {
  let {
      size: sizeProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      color: colorProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      alignWithText = false,
      'aria-label': ariaLabel,
      id
    } = _ref,
    restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const theme = useTheme();
  const dataProps = getDataProps(restProps);

  // Setting default values here
  const size = sizeProp !== null && sizeProp !== void 0 ? sizeProp : 'inherit';
  const color = colorProp !== null && colorProp !== void 0 ? colorProp : 'inherit';
  const sizeValue = useIconSize(size);
  const sizeCSSValue = sizeProp ? `${sizeValue} !important` : sizeValue; // Adds the `!important` flag to the `size` value if one is provided via props

  const colorValue = color === 'inherit' ? 'currentColor' : theme.color[color]; // inherit = currentColor = text color of the parent element
  const colorCSSValue = colorProp ? `${colorValue} !important` : colorValue; // Adds the `!important` flag to the `color` value if one is provided via props

  return /*#__PURE__*/_jsxs(StyledIcon, Object.assign({}, dataProps, {
    $size: sizeCSSValue,
    $color: colorCSSValue,
    $alignWithText: alignWithText,
    "aria-label": ariaLabel,
    "aria-hidden": ariaLabel === undefined ? true : undefined,
    id: id,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    focusable: "false",
    "data-icon-name": "Communication",
    children: [/*#__PURE__*/_jsx("path", {
      d: "M2.29 30.96c-.15 0-.3-.03-.44-.09-.43-.18-.71-.59-.71-1.06V5.28a4.03 4.03 0 0 1 4.03-4.03h21.65c2.22 0 4.03 1.81 4.03 4.03v14.44c0 2.22-1.81 4.03-4.03 4.03H9.98L3.1 30.63c-.22.22-.51.33-.81.33M5.17 3.53c-.96 0-1.75.78-1.75 1.74v21.78l5.27-5.27c.23-.23.54-.35.86-.33h17.27c.96 0 1.75-.78 1.75-1.75V5.28c0-.96-.78-1.74-1.75-1.74H5.17Z"
    }), /*#__PURE__*/_jsx("path", {
      d: "M17.77 16.1H6.86a1.14 1.14 0 1 1 0-2.28h10.91a1.14 1.14 0 1 1 0 2.28M25.14 11.53H6.86a1.14 1.14 0 1 1 0-2.28h18.28a1.14 1.14 0 1 1 0 2.28"
    })]
  }));
};
CommunicationIcon.displayName = 'CommunicationIcon';